export default "__VITE_ASSET__109f4594__"